interface FeedbackStarIconProps {
  className?: string;
}

/**
 * Star glyph used by the learner feedback Likert scale. The fill uses
 * `currentColor` so the parent component picks the active color via
 * Tailwind utilities — `text-warning-500` for the filled (default) state and
 * `text-text-tertiary/50` (or any neutral) for the empty/grey state.
 */
export default function FeedbackStarIcon({ className }: FeedbackStarIconProps) {
  return (
    <svg
      width="52"
      height="52"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M37.6078 44.9749C37.2653 44.9763 36.9274 44.8955 36.6226 44.7393L25.7001 39.021L14.7776 44.7393C14.4229 44.9258 14.023 45.0091 13.6234 44.9796C13.2238 44.9501 12.8404 44.8092 12.5169 44.5727C12.1934 44.3362 11.9428 44.0137 11.7934 43.6418C11.6441 43.27 11.6021 42.8637 11.6722 42.4691L13.8139 30.4116L4.99019 21.8449C4.71489 21.5702 4.5196 21.2257 4.42527 20.8484C4.33095 20.471 4.34114 20.0752 4.45477 19.7032C4.5789 19.3226 4.80724 18.9844 5.11387 18.727C5.4205 18.4695 5.79314 18.3032 6.18952 18.2469L18.397 16.4693L23.7726 5.48255C23.948 5.12046 24.2218 4.81508 24.5627 4.60141C24.9036 4.38774 25.2978 4.27441 25.7001 4.27441C26.1024 4.27441 26.4966 4.38774 26.8375 4.60141C27.1784 4.81508 27.4522 5.12046 27.6276 5.48255L33.0674 16.4479L45.2749 18.2255C45.6713 18.2818 46.044 18.4481 46.3506 18.7055C46.6572 18.963 46.8856 19.3012 47.0097 19.6818C47.1233 20.0538 47.1335 20.4496 47.0392 20.8269C46.9449 21.2042 46.7496 21.5487 46.4743 21.8235L37.6506 30.3901L39.7923 42.4477C39.8687 42.8492 39.8287 43.2642 39.6769 43.6437C39.5251 44.0232 39.2679 44.3514 38.9356 44.5894C38.5478 44.8612 38.0808 44.9967 37.6078 44.9749Z"
        fill="currentColor"
      />
    </svg>
  );
}
